const config = {
  // <<<<<<< HEAD
  development: {
    // backendUrl: "http://localhost:4000",
    backendUrl: "https://backend.techsharthiacademy.com",
    RAZORPAY_KEY_ID: "rzp_live_69mgc4bYYmxNr3",
    // RAZORPAY_KEY_ID: "rzp_test_tzjr0X9rDyNbCu",
  },
  production: {
    // backendUrl: "http://localhost:4000",
    backendUrl: "https://backend.techsharthiacademy.com",
    RAZORPAY_KEY_ID: "rzp_live_69mgc4bYYmxNr3",
    // RAZORPAY_KEY_ID: "rzp_test_tzjr0X9rDyNbCu",
  },
};


export default config[process.env.NODE_ENV || "development"];
// =======
//   development: {
//     backendUrl: "http://localhost:4000",
//     //backendUrl: 'https://techsharthiacademy.com/backend'
//   },
//   production: {
//     backendUrl: "https://api.yourdomain.com",
//     //backendUrl: 'https://techsharthiacademy.com/backend'
//   },
// };

// export default config[process.env.NODE_ENV || "development"];
// >>>>>>> a1d594f154399d98c80996763e7540307bbfdf78
